var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { DeControlsModule } from '@synisys/idm-de-service-client-js';
import { DynamicFormControlsModule } from '@synisys/idm-dynamic-forms-controls';
import { ControlsModule } from '@synisys/idm-ng-controls';
import { FlashMessagesModule } from 'angular2-flash-messages';
import { CellComponent } from './component/cell';
import { ControlComponent } from './component/control';
import { GridComponent } from './component/grid';
import { RowComponent } from './component/row';
import { MaterialModule } from './material.module';
var DynamicLayoutModule = /** @class */ (function () {
    function DynamicLayoutModule() {
    }
    DynamicLayoutModule = __decorate([
        NgModule({
            imports: [
                CommonModule,
                FormsModule,
                ControlsModule,
                DynamicFormControlsModule,
                FlashMessagesModule.forRoot(),
                MaterialModule,
                DeControlsModule,
            ],
            declarations: [
                ControlComponent,
                GridComponent,
                RowComponent,
                CellComponent,
            ],
            exports: [ControlComponent, GridComponent, RowComponent, CellComponent],
        })
    ], DynamicLayoutModule);
    return DynamicLayoutModule;
}());
export { DynamicLayoutModule };
//# sourceMappingURL=dynamic-layout.module.js.map